import { Link } from "wouter";

export default function SiteFooter({ showContactCta = true }: { showContactCta?: boolean }) {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#2C2C31] text-white">
      {/* CTA band */}
      {showContactCta && <div className="bg-[#3A3A3F] py-14 text-center">
        <p className="text-[#B7C0CD] text-sm uppercase tracking-widest mb-3">How can we optimize your property?</p>
        <Link
          href="/contact"
          className="inline-block bg-[#C9421D] hover:bg-[#A83318] text-white font-bold px-8 py-3.5 uppercase tracking-widest text-sm transition-colors"
          style={{ borderRadius: 0 }}
        >
          LET'S TALK
        </Link>
      </div>}

      <div className="container py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        {/* Brand */}
        <div className="lg:col-span-1">
          <img src="https://storage.googleapis.com/fcmre-media/assets/fcmre-logo.png" alt="FCMRE" width={142} height={40} loading="lazy" decoding="async" className="h-10 w-auto mb-5" />
          <p className="text-white/70 text-sm leading-relaxed">
            First Class Management Real Estate — New York City's premier full-service property management company.
          </p>
        </div>

        {/* Services */}
        <div>
          <p className="text-xs font-bold uppercase tracking-widest text-[#F0A03C] mb-5">Services</p>
          <ul className="space-y-2.5 text-sm text-white/70">
            <li><Link href="/services/retail" className="hover:text-white transition-colors">Retail & Commercial</Link></li>
            <li><Link href="/services/residential" className="hover:text-white transition-colors">Residential & Mixed-Use</Link></li>
            <li><Link href="/services/condo" className="hover:text-white transition-colors">Condominium & Co-Op</Link></li>
          </ul>
        </div>

        {/* Company */}
        <div>
          <p className="text-xs font-bold uppercase tracking-widest text-[#F0A03C] mb-5">Company</p>
          <ul className="space-y-2.5 text-sm text-white/70">
            <li><Link href="/about" className="hover:text-white transition-colors">About Us</Link></li>
            <li><Link href="/properties" className="hover:text-white transition-colors">Properties</Link></li>
            <li><Link href="/forms" className="hover:text-white transition-colors">Forms</Link></li>
            <li><Link href="/insights" className="hover:text-white transition-colors">Insights</Link></li>
            <li><Link href="/contact" className="hover:text-white transition-colors">Contact Us</Link></li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <p className="text-xs font-bold uppercase tracking-widest text-[#F0A03C] mb-5">Contact</p>
          <ul className="space-y-3 text-sm text-white/70">
            <li>
              <a href="tel:+12129189037" className="hover:text-white transition-colors">(212) 918-9037</a>
            </li>
            <li>
              <a href="mailto:contact@fcmre.com" className="hover:text-white transition-colors">contact@fcmre.com</a>
            </li>
            <li>
              <a href="https://fcmre.unitconnect.com/tenant/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Tenant Login</a>
            </li>
            <li className="text-white/70 text-xs leading-relaxed pt-1">
              New York, NY
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/70">
          <span>© {year} FCMRE – First Class Management Real Estate. All rights reserved.</span>
          <div className="flex gap-4">
            <Link href="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link href="/terms" className="hover:text-white transition-colors">Terms of Use</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
